import { render, staticRenderFns } from "./TabelaBase.vue?vue&type=template&id=66b41c8f&scoped=true"
import script from "./TabelaBase.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaBase.vue?vue&type=style&index=0&id=66b41c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b41c8f",
  null
  
)

export default component.exports